module.exports = __webpack_public_path__ + "static/media/location.07f467a8.svg";